import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { appInjector } from '../app-injector';
import { BaseComponent } from '../base-component';

@Component({
  selector: 'app-load-modal',
  templateUrl: './load-modal.component.html',
  styleUrls: ['./load-modal.component.css']
})
export class LoadModalComponent extends BaseComponent {
  message: string;
  constructor() {
    super();
  }
  static modal: BsModalRef;

  static show() {
    LoadModalComponent.hidden = false;
    // return new Promise<void>(async resolve => {
    const modalService = appInjector.get(BsModalService);
    LoadModalComponent.modal = modalService.show(LoadModalComponent, {
      backdrop: true,
      ignoreBackdropClick: true,
      animated: false
    });

    // modalService.
    const subscription = modalService.onShow.subscribe(() => {
      if (LoadModalComponent.hidden) {
        LoadModalComponent.modal.hide();
      }
    })
  }

  private static hidden = true;
  static hide() {
    LoadModalComponent.hidden = true;
    LoadModalComponent.modal.hide();

  }
}
